<ion-list lines="none">
  <div *ngFor="let participant of participantsInChatGroup; last as last">
    <ion-item *ngIf="participant.name" [lines]="last ? 'none' : 'full'">
      <ion-label>
        {{ participant.name }}
      </ion-label>

      <ion-checkbox
        mode="md"
        [checked]="participant.isChecked"
        (ionChange)="toggleParticipantInChatGroup($event, participant)"
        slot="end"></ion-checkbox>
    </ion-item>
  </div>
</ion-list>
